export const text = '#1C1C1C';
export const hover = '#484848';
export const title = `'PP Fragment Serif', Arial, Helvetica, freesans, sans-serif `